// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Domain_LocalResourcesDefinition  {
    _originalTypeClassName = "LoomTenantManagement.BO.Domain_LocalResourcesDefinition";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Domain_LocalResourcesDefinition.translate = translateService;
}
this.TenantBO_Res_ASSOC_LoomModule_EnabledLoomModule_LoomModule = null;
this.Res_ENUM_TenantStatus_Active = null;
this.Res_ENUM_TenantStatus_Suspended = null;
this.Res_ENUM_TenantStatus_Cancelled = null;
this.Res_ENUM_SubscriptionPlans_Basic = null;
this.Res_ENUM_SubscriptionPlans_Pro = null;
this.Res_ENUM_SubscriptionStatus_Active = null;
this.Res_ENUM_SubscriptionStatus_Expired = null;
this.Res_ENUM_SubscriptionStatus_Cancelled = null;
}

static translate: TranslateService;
_key: any;
TenantBO_Res_ASSOC_LoomModule_EnabledLoomModule_LoomModule:any;
Res_ENUM_TenantStatus_Active:any;
Res_ENUM_TenantStatus_Suspended:any;
Res_ENUM_TenantStatus_Cancelled:any;
Res_ENUM_SubscriptionPlans_Basic:any;
Res_ENUM_SubscriptionPlans_Pro:any;
Res_ENUM_SubscriptionStatus_Active:any;
Res_ENUM_SubscriptionStatus_Expired:any;
Res_ENUM_SubscriptionStatus_Cancelled:any;




}